import { render, staticRenderFns } from "./UtilGuard.vue?vue&type=template&id=06674a20"
import script from "./UtilGuard.vue?vue&type=script&lang=js"
export * from "./UtilGuard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports